import { observer } from "mobx-react"
import { playerStore } from "../../../store/player.store"

const SupportForm = observer(() => {

  if (!playerStore.isInForm) return <></>

  return (
    <div className='form-wrap'>
      <div className="form">
        {
          !playerStore.isPenInPlayer && (
            <div className="form-note">Please find a pen to fill form</div>
          )
        }
        <div>
          <h4>Name</h4>
          <input
            value={playerStore.formData.name}
            onChange={e => {
              playerStore.changeFormData("name", e.target.value)
            }}
            type="text"
            className="form-input"
          />
        </div>
        <div>
          <h4>Email</h4>
          <input
            value={playerStore.formData.email}
            onChange={e => playerStore.changeFormData("email", e.target.value)}
            type="text"
            className="form-input"
          />
        </div>
        <div>
          <h4>Message</h4>
          <textarea
            value={playerStore.formData.message}
            onChange={e => playerStore.changeFormData("message", e.target.value)}
            className="form-area"
          />
        </div>

        <button
          className="form-btn"
          onClick={() => playerStore.hideForm()}
        >
          Save
        </button>
      </div>
    </div>
  )
})

export {
  SupportForm
}